import { useMutateBatchDenyTravels } from '../../models'

// Toasts live in the composing Feature Set (`TravelApprovalListView`) —
// rejections propagate to the caller (ADR-10 via getMessageFromError there).
export const useBatchDenyTravelsPresenter = () => {
  const { batchDeny, isDenying } = useMutateBatchDenyTravels()

  const batchDenyCommand = async (travelIds: number[]): Promise<void> => {
    // BHV-033: double-submit guard
    if (isDenying) return

    await batchDeny(travelIds)
  }

  return {
    commands: {
      batchDeny: batchDenyCommand,
    },
    states: {
      isSubmitting: isDenying,
    },
  }
}
